import React from "react";
import styled from "styled-components";
import { AudioOutlined } from "@ant-design/icons";
import { Input as AntInput, InputRef } from "antd";

interface ISearchFormProps {
    placeholder?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    size?: "large" | "middle" | "small";
    isHideVoice?: boolean;
    isPrimary?: boolean;
    width?: string;
    height?: number;
    onFocus?: (event?: React.FocusEvent<HTMLInputElement>) => void;
}

const SearchInput = styled(AntInput.Search)<{
    $width?: string;
    $height?: number;
    isPrimary?: boolean;
}>`
    width: ${props => props.$width || "100%"};
    border-radius: 100px;
    transition:
        background 0.3s ease,
        transform 0.1s ease;

    &:active {
        transform: scale(0.98);
    }

    .ant-input-search-button {
        color: ${({ isPrimary }) =>
            isPrimary ? "var(--main-search-bar-search-icon)" : "var(--secondary-search-bar-search-icon)"};
        border: 1px solid
            ${({ isPrimary }) => (isPrimary ? "var(--main-search-bar-stroke)" : "var(--secondary-search-bar-stroke)")};
        font-size: 18px;

        &:hover {
            background-color: ${({ isPrimary }) =>
                isPrimary
                    ? "var(--main-search-bar-action-background-hover) !important"
                    : "var(--secondary-search-bar-action-background-hover) !important"};
        }

        background-color: ${({ isPrimary }) =>
            isPrimary
                ? "var(--main-search-bar-action-background) !important"
                : "var(--secondary-search-bar-action-background) !important"};
    }

    .ant-input {
        &::placeholder {
            color: ${({ isPrimary }) =>
                isPrimary ? "var(--main-search-bar-text)" : "var(--secondary-search-bar-text)"} !important;
        }
    }

    .ant-input-outlined {
        max-height: ${({ isPrimary }) => (isPrimary ? "40px" : "38px")};
        background-color: ${({ isPrimary }) =>
            isPrimary ? "var(--main-search-bar-fill)" : "var(--secondary-search-bar-fill)"};
        border: 1px solid
            ${({ isPrimary }) => (isPrimary ? "var(--main-search-bar-stroke)" : "var(--secondary-search-bar-stroke)")};
        color: ${({ isPrimary }) => (isPrimary ? "var(--main-search-bar-text)" : "var(--secondary-search-bar-text)")};

        &::placeholder {
            color: ${({ isPrimary }) =>
                isPrimary ? "var(--main-search-bar-text)" : "var(--secondary-search-bar-text)"} !important;
        }
    }
`;

const SearchForm = React.forwardRef<InputRef, ISearchFormProps>(
    (
        {
            placeholder = "Search",
            onClick,
            onChange,
            value,
            size = "large",
            style,
            isHideVoice = true,
            isPrimary = true,
            width = "100%",
            onFocus,
        },
        ref
    ) => {
        return (
            <SearchInput
                placeholder={placeholder}
                enterButton
                size={size}
                onSearch={onClick}
                onChange={onChange}
                onFocus={event => onFocus?.(event)}
                value={value}
                isPrimary={isPrimary}
                style={style}
                $width={width}
                ref={ref}
                suffix={isHideVoice && <AudioOutlined style={{ fontSize: 16, color: "var(--main-search-bar-mic)" }} />}
            />
        );
    }
);

SearchForm.displayName = "SearchForm";

export default SearchForm;
